let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lrul5")).then(() => parcelRequire('d8l6O'));